import React from 'react';
import { StyledDot, StyledLabel, StyleDotWrapper } from './styled';
import { Tooltip } from 'antd';

const EventLabel: React.FC<{
  tooltip?: string;
  text?: React.ReactNode;
  prefix?: React.ReactNode;
}> = ({
  tooltip,
  text = 'Error Event',
  prefix = (
    <StyleDotWrapper>
      <StyledDot />
    </StyleDotWrapper>
  ),
}) => (
  <Tooltip title={tooltip}>
    <StyledLabel>
      {prefix}
      <span style={{ flexShrink: 0 }}>{text}</span>
    </StyledLabel>
  </Tooltip>
);

export default EventLabel;
